/**
 * Raised when an all-in-one carrier token is no longer valid.
 *
 * TODO - Replace `rate-command-center/domain/errors/TokenExpiredError` usages with this deffinition
 **/
export class TokenExpiredError extends Error {
  constructor() {
    super('Token expired.')
    this.name = 'TokenExpiredError'
  }
}
